import { IGetByFilterResponse } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import { useAppDispatch } from 'src/hooks/app';
import { useFetchExploreArts, useLoading, usePager, useTotal, useVisibleTotal } from './use-explore-arts';
import { actions } from '../ducks/explore-arts/explore-arts.slice';

export const useInfiniteExploreTokens = ({ limit = 12 }) => {
    const visibleTotal = useVisibleTotal();
    const pager = usePager();
    const total = useTotal();
    const loading = useLoading();
    const dispatch = useAppDispatch();
    const fetchExploreArts = useFetchExploreArts();

    const setPage = useCallback(
        async (page: number) => {
            await dispatch(actions.setPage(page));
        },
        [dispatch]
    );

    const restoreInitialState = useCallback(
        async ({ total, visibleTotal, page }: { page: number; total: number; visibleTotal: number }) => {
            await dispatch(actions.restoreState({ total, visibleTotal, page }));
        },
        [dispatch]
    );

    const fetch = useCallback(
        async ({ page = 0 }) => {
            dispatch(actions.setLoading(true));
            let data = {} as IGetByFilterResponse;
            try {
                dispatch(actions.setPage(page));
                if (page === 0) {
                    dispatch(actions.clearItems());
                }
                // @ts-ignore
                data = await fetchExploreArts({
                    pager: { limit, page },
                });
            } catch (err) {
                console.error('Home.Explore.Fetch Arts', err);
            } finally {
                dispatch(actions.setLoading(false));
            }
            return data;
        },
        [dispatch, fetchExploreArts, limit]
    );

    return {
        pager,
        setPage,
        restoreInitialState,
        fetch,
        total,
        loading,
        visibleTotal,
    };
};
